(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3508],{

/***/ 83508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Modal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./components/templates/components/Modal/styles.module.scss
var styles_module = __webpack_require__(85130);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./providers/modalProvider.js
var modalProvider = __webpack_require__(51472);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/elements/Button/index.js + 2 modules
var Button = __webpack_require__(41197);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-modal-close.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconModalClose = props => /*#__PURE__*/react.createElement("svg", _extends({
  viewBox: "0 0 9 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.707 4.293 8.071.929 7.364.222 4 3.586.707.293 0 1l3.293 3.293-3 3L1 8l3-3 3.071 3.07.707-.706-3.07-3.071Z",
  fill: "currentColor"
})));

/* harmony default export */ var icon_modal_close = (SvgIconModalClose);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/templates/components/Modal/index.js









var Modal = function(param) {
    var translations = param.translations;
    var ref = (0,modalProvider/* useModalContext */.vR)(), show = ref.show, variant = ref.variant, handleCloseModal = ref.handleCloseModal, content = ref.content;
    var isSmallMobile = (0,ResponsiveContext/* useResponsive */.F)().isSmallMobile;
    var isOutsideClose = !variant.includes("prevent-outside-close");
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,withModifiers/* withModifiers */.i)("modal", [
            show && "is-active"
        ].concat((0,_to_consumable_array/* default */.Z)(variant)), (styles_module_default())),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return isOutsideClose && handleCloseModal();
                },
                className: (styles_module_default()).modal__offcanvas
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).modal__content,
                children: [
                    content,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        className: (styles_module_default()).modal__close,
                        onClick: function() {
                            return handleCloseModal();
                        },
                        variant: [
                            "label"
                        ],
                        arrow: false,
                        prepend: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_modal_close, {
                            width: isSmallMobile ? 15 : 9,
                            height: isSmallMobile ? 15 : 9
                        }),
                        children: !isSmallMobile && translations.close[router.locale]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Modal = (Modal);


/***/ }),

/***/ 51472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ny": function() { return /* binding */ ModalContextProvider; },
/* harmony export */   "vR": function() { return /* binding */ useModalContext; }
/* harmony export */ });
/* unused harmony export ModalContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);




var ModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useModalContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ModalContext);
    if (context === undefined) {
        throw new Error("useModalContext was used outside of its Provider");
    }
    return context;
};
var ModalContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), content = ref1[0], setContent = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), variant = ref2[0], setVariant = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), beforeClose = ref3[0], handleBeforeClose = ref3[1];
    var body =  true && document.querySelector("body");
    var handleShowModal = function() {
        setShow(true);
        body.classList.add("modal-open");
    };
    var handleCloseModal = function() {
        setShow(false);
        body.classList.remove("modal-open");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (show) {
            beforeClose && beforeClose();
            handleCloseModal();
        }
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalContext.Provider, {
        value: {
            handleShowModal: handleShowModal,
            handleCloseModal: handleCloseModal,
            handleBeforeClose: handleBeforeClose,
            setContent: setContent,
            content: content,
            setVariant: setVariant,
            show: show,
            variant: variant
        },
        children: children
    });
};



/***/ }),

/***/ 85130:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__ZdKUt","modal--is-active":"styles_modal--is-active__pyWTo","modal__content":"styles_modal__content__c7H6R","modal__offcanvas":"styles_modal__offcanvas__9YekT","modal__close":"styles_modal__close__LXyvJ","modal--contained":"styles_modal--contained__ONCK9","modal--xs":"styles_modal--xs__6DdSx"};

/***/ })

}]);